import React from 'react';
import cx from 'classnames';

import Toggle from '../Toggle';

export interface Props {
  children: React.ReactNode;
  className?: Parameters<typeof cx>[0];
  disabled?: boolean;
  id: string;
  name?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  right?: boolean;
  value: boolean;
  trueText?: string;
  falseText?: string;
}

export const ToggleSwitch: React.FC<Props> = props => {
  return <Toggle {...props}>{props.children}</Toggle>;
};

ToggleSwitch.displayName = 'ToggleSwitch';
export default ToggleSwitch;
